import { render } from "./DataLayout.vue?vue&type=template&id=ec71f606&scoped=true"
import script from "./DataLayout.vue?vue&type=script&lang=js"
export * from "./DataLayout.vue?vue&type=script&lang=js"

import "./DataLayout.vue?vue&type=style&index=0&id=ec71f606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec71f606"]])

export default __exports__